import * as React from 'react'
import { ComponentsState, ErrorComponentsState } from 'piral'
import { Focusable } from '@medialib/styleguide'
import Navigation from './components/Navigation'
import App from './components/App'
import { Link } from 'react-router-dom'

export const layout: Partial<ComponentsState> = {
  Layout: App,
  MenuContainer: Navigation,
  // Every menu entry is a spatial-navigation stop, so a remote can get from the
  // rows back up to the main navigation. The pilets registering menu items stay
  // unaware of it — the shell owns the menu chrome. The <li> lives in Navigation
  // (the MenuContainer, which owns the <ul>); adding one here too nested <li> in
  // <li> — an invalid-DOM-nesting warning at runtime.
  MenuItem: ({ children }) => <Focusable className='mlsg-focusable--inline'>{children}</Focusable>,
}

export const errors: Partial<ErrorComponentsState> = {
  not_found: () => (
    <div className='Error'>
      <p className='Error__message'>Could not find the requested page. Are you sure it exists?</p>
      <p>
        Go back <Link to='/'>to the homepage</Link>.
      </p>
    </div>
  ),
}
